import classnames from 'classnames';

import { StepperInput } from '@/core/tamagoshi/StepperInput/StepperInput';

import { decrementLabel, incrementLabel } from './translations';
import { useQuantitySelector } from './useQuantitySelector';

import styles from './styles.module.scss';

interface QuantitySelectorProps {
  className?: string;
}

export const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  className,
}) => {
  const { quantity, stock, onStepperChange, isSellable, totalStock } =
    useQuantitySelector();

  return (
    <StepperInput
      className={classnames(styles.stepperInput, className)}
      onChange={onStepperChange}
      name="product-quantity"
      data-testid="product-quantity"
      value={quantity}
      min={stock?.minimumValue}
      max={totalStock || undefined}
      step={stock?.increaseQuantity}
      isDisabled={!isSellable}
      incrementLabel={incrementLabel}
      decrementLabel={decrementLabel}
    />
  );
};

QuantitySelector.displayName = 'QuantitySelector';
